export const EstadosConversacion = Object.freeze({
  ESPERANDO_RESPUESTA_PRESTADOR: 1,
  ESPERANDO_RESPUESTA_ART: 2,
  CERRADA: 3,
});

export const EstadosConversacionTextos = Object.freeze({
  [EstadosConversacion.ESPERANDO_RESPUESTA_PRESTADOR]: "Esperando Respuesta Prestador",
  [EstadosConversacion.ESPERANDO_RESPUESTA_ART]: "Esperando Respuesta ART",
  [EstadosConversacion.CERRADA]: "Cerrada",
});

export const EstadosMensaje = Object.freeze({
  ENVIADO: 1,
  LEIDO: 2,
});

export const EstadosMensajeTextos = Object.freeze({
  [EstadosMensaje.ENVIADO]: "Enviado",
  [EstadosMensaje.LEIDO]: "Leído",
});
